import React from "react";
import StepNavigation from "../../components/addListing/StepNavigation";
import { useTranslation } from "react-i18next";
import "../../styles/steps.css";

export default function StepRenovationDetails({
  listing,
  setListing,
  onBack,
  onNext,
}) {
  const { t } = useTranslation();

  const handleChange = (field, value) => {
    setListing((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const isNextDisabled =
    !listing.title?.trim() ||
    !listing.price ||
    Number(listing.price) <= 0;

  return (
    <div className="step">

      <h2 className="step-title">
        {t("renovation.stepDetailsTitle")}
      </h2>

      {/* =========================
          PRODUCT NAME
      ========================== */}

      <div className="form-group">

        <label className="form-label">
          {t("renovation.productName")}
          <span className="required">*</span>
        </label>

        <input
          type="text"
          className="form-input"
          value={listing.title || ""}
          onChange={(e) =>
            handleChange("title", e.target.value)
          }
          placeholder={t(
            "renovation.productNamePlaceholder"
          )}
        />

      </div>

      {/* =========================
          BRAND
      ========================== */}

      <div className="form-group">

        <label className="form-label">
          {t("renovation.brand")}
        </label>

        <input
          type="text"
          className="form-input"
          value={listing.brand || ""}
          onChange={(e) =>
            handleChange("brand", e.target.value)
          }
          placeholder={t(
            "renovation.brandPlaceholder"
          )}
        />

      </div>

      {/* =========================
          CONDITION
      ========================== */}

      <div className="form-group">

        <label className="form-label">
          {t("renovation.condition")}
        </label>

        <div className="option-grid small">

          <button
            type="button"
            className={`option-card ${
              listing.condition === "new"
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleChange("condition", "new")
            }
          >
            {t("renovation.new")}
          </button>

          <button
            type="button"
            className={`option-card ${
              listing.condition === "old"
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleChange("condition", "old")
            }
          >
            {t("renovation.old")}
          </button>

          <button
            type="button"
            className={`option-card ${
              listing.condition === "in_process"
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleChange("condition", "in_process")
            }
          >
            {t("renovation.in_process")}
          </button>

        </div>

      </div>


{/* =========================
    WARRANTY
========================== */}

<div className="form-group">

  <label className="form-label">
    {t("renovation.warranty")}
  </label>

  <div className="option-grid small">

    <button
      type="button"
      className={`option-card ${
        listing.warranty === true ? "active" : ""
      }`}
      onClick={() =>
        handleChange("warranty", true)
      }
    >
      {t("common.yes")}
    </button>

    <button
      type="button"
      className={`option-card ${
        listing.warranty === false ? "active" : ""
      }`}
      onClick={() =>
        setListing((prev) => ({
          ...prev,
          warranty: false,
          warrantyPeriod: "",
          warrantyDetails: "",
        }))
      }
    >
      {t("common.no")}
    </button>

  </div>


  {/* WARRANTY DETAILS */}

  {listing.warranty === true && (
    <div className="renovation-warranty-details">

      <div className="form-group">

        <label className="form-label">
          {t("renovation.warrantyPeriod")}
        </label>

        <input
          type="text"
          className="form-input"
          value={listing.warrantyPeriod || ""}
          onChange={(e) =>
            handleChange(
              "warrantyPeriod",
              e.target.value
            )
          }
          placeholder={t(
            "renovation.warrantyPeriodPlaceholder"
          )}
        />

      </div>


      <div className="form-group">

        <label className="form-label">
          {t("renovation.warrantyDetails")}
        </label>

        <textarea
          rows={3}
          className="form-input"
          value={listing.warrantyDetails || ""}
          onChange={(e) =>
            handleChange(
              "warrantyDetails",
              e.target.value
            )
          }
          placeholder={t(
            "renovation.warrantyDetailsPlaceholder"
          )}
        />

      </div>

    </div>
  )}

</div>



      {/* =========================
          PRICE
      ========================== */}

      <div className="form-group">

        <label className="form-label">
          {t("renovation.price")}
          <span className="required">*</span>
        </label>

        <input
          type="number"
          min="0"
          className="form-input"
          value={listing.price || ""}
          onChange={(e) =>
            handleChange("price", e.target.value)
          }
          placeholder={t(
            "renovation.pricePlaceholder"
          )}
        />

      </div>

      {/* =========================
          QUANTITY + UNIT
      ========================== */}

      <div className="form-group">

        <label className="form-label">
          {t("renovation.quantity")}
        </label>

        <input
          type="number"
          min="0"
          className="form-input"
          value={listing.quantity || ""}
          onChange={(e) =>
            handleChange("quantity", e.target.value)
          }
          placeholder={t(
            "renovation.quantityPlaceholder"
          )}
        />

      </div>

      <div className="form-group">

        <label className="form-label">
          {t("renovation.unit")}
        </label>

        <select
          className="form-input"
          value={listing.unit || ""}
          onChange={(e) =>
            handleChange("unit", e.target.value)
          }
        >

          <option value="">
            {t("renovation.selectUnit")}
          </option>

          <option value="piece">
            {t("renovation.units.piece")}
          </option>

          <option value="m2">
            m²
          </option>

          <option value="m3">
            m³
          </option>

          <option value="kg">
            kg
          </option>

          <option value="liter">
            {t("renovation.units.liter")}
          </option>

          <option value="meter">
            {t("renovation.units.meter")}
          </option>

        </select>

      </div>

      {/* =========================
          NAVIGATION
      ========================== */}

      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextDisabled={isNextDisabled}
      />

    </div>
  );
}
